import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { State } from '../State';
import { EmployeeSalaryTypeActions } from '../State/actions/employee-salary-type.actions';
import {
    getEmployeeSalaryTypeFetched,
    getEmployeeSalaryTypeLatestUpdatedAt,
} from '../State/selectors/employee-salary-type.selector';
import { BaseEntityReloadResolver2, BaseEntityResolver } from './resolver.helper';

@Injectable({
    providedIn: 'root',
})
export class EmployeeSalaryTypeResolver extends BaseEntityReloadResolver2 {
    constructor(store: Store<State>) {
        super(getEmployeeSalaryTypeFetched, getEmployeeSalaryTypeLatestUpdatedAt, EmployeeSalaryTypeActions.load, store);
    }
}
